import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Dashboard/Home'
import Orders from '../views/Dashboard/Orders'
import Login from '../views/Login'
import Dashboard from '../views/Dashboard'
import NotFound from '../views/NotFound'
import Customers from '../views/Dashboard/Customers'
import Products from '../views/Dashboard/Products'
import Users from '../views/Dashboard/Users'
import Rep from '../views/Dashboard/Rep'
import Settings from '../views/Dashboard/Settings'
import Outstanding from '../views/Dashboard/Outstandings'
Vue.use(VueRouter)
const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
  },

  /* {
     path: "/:catchAll(.*)",
     component: NotFound,
   },*/
  {
    path: "/",
    name: "Dashboard",
    component: Dashboard,

    children: [
      {
        path: "/", redirect: '/home',
      },
      {
        path: "/home",
        name: "Dashboard",
        component: Home,
      }, {
        path: "/orders",
        name: "Orders",
        component: Orders,
      }, {
        path: "/cust",
        name: "Customers",
        component: Customers,
      },
      {
        path: "/outs",
        name: "Outstandings",
        component: Outstanding,
      },
      {
        path: "/products",
        name: "Products",
        component: Products,
      },

      {
        path: "/users",
        name: "Users",
        component: Users,
      },

      {
        path: "/rep",
        name: "Reps",
        component: Rep,
      }, {
        path: "/settings",
        name: "Settings",
        component: Settings,
      },
      {
        path: "/:catchAll(.*)",
        component: NotFound,
      },
    ]

  },
  {
    path: "/:catchAll(.*)",
    component: NotFound,
  },

];


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
